module.exports = __webpack_public_path__ + "img/380d441.png";